module.exports = __webpack_public_path__ + "static/media/Acknowledged.7c0cd500.svg";